<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal feed_image_modal" role="dialog">
    <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
            <!-- Modal-Header -->
            <div class="close-modal">
                <span (click)="dialogClose()" class="modal-close-icon"><i class="material-icons">close</i></span>
            </div>
            <!-- Modal content-->
            <div mat-dialog-content>
                <!-- Modal-Body -->
                <div class="modal-body">
                    
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <video controls class="full-video">
                                    <source [src]="data?.url" type="video/mp4">
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>